import React from 'react';
import PropTypes from 'prop-types';
import forEach from 'lodash/forEach';
import Card from 'zignal-landscape/lib/Card';
import TabbedPanes from 'zignal-landscape/lib/TabbedPanes';
import Tabs from 'zignal-landscape/lib/Tabs';
import Tab from 'zignal-landscape/lib/Tab';
import Panes from 'zignal-landscape/lib/Panes';
import Pane from 'zignal-landscape/lib/Pane';
import Schedule from './Schedule.js';
import Email from './Email.js';
import styles from './ReportForm.css';

function ReportForm(props) {
  const {report, user, jobs} = props;
  const tabData = [
    {
      label: 'Send as Email',
      pane: <Email {...props} />
    }
  ];

  if(report && report.user === user.id && jobs) {
    // There could be two jobs per report (Scheduled and Event). We removed the Event tab,
    // but still need to filter out remaing Event jobs until we remove them all from mongo.
    // Easiest way to filter is to look for `is_cumulative`
    const [job={}] = jobs.filter(({is_cumulative}) => !is_cumulative);
    tabData.push({
      label: 'Schedule',
      pane: <Schedule {...props} job={job} />
    });
  }

  const tabs = tabData.map((tabInfo, index) => (
    <Tab key={`tab_${index}`}>
      <span className={styles.tabLabel}>{tabInfo.label}</span>
    </Tab>
  ));

  const panes = tabData.map((tabInfo, index) => (
    <Pane key={`pane_${index}`}>
      {tabInfo.pane}
    </Pane>
  ));

  return (
    <div className={styles.tabPanes}>
      <Card>
        <TabbedPanes>
          <Tabs>
            {tabs}
          </Tabs>
          <Panes>
            {panes}
          </Panes>
        </TabbedPanes>
      </Card>
    </div>
  );
}

ReportForm.propTypes = {
  report: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  users: PropTypes.array.isRequired,
  jobs: PropTypes.array
};


export default ReportForm;
